import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Subject, debounceTime } from 'rxjs';
import { BranchManagementService } from 'src/app/services/branch-management.service';
import { ExportExcelService } from 'src/app/services/export-excel.service';
import { StorageService } from 'src/app/services/storage.service';
import { UserDashboardService } from 'src/app/services/user-dashboard.service';
import * as XLSX from 'xlsx';
import { DialogService } from 'primeng/dynamicdialog';
import { BulkResultComponent } from 'src/app/bulk-result/bulk-result.component';
import { TableColumn } from 'src/app/shared-components/data-table/data-table.component';

@Component({
    selector: 'app-branch-lisitng',
    templateUrl: './branch-lisitng.component.html',
    styleUrls: ['./branch-lisitng.component.scss'],
    standalone: false
})
export class BranchLisitngComponent implements OnInit {
  readonly columns: TableColumn[] = [
    { field: 'id', header: 'Branch ID' },
    { field: 'name', header: 'Name' },
    { field: 'branch_code', header: 'Branch Code' },
    { field: 'account_name', header: 'Account Name' },
    { field: 'branch_type_display', header: 'Type' },
    { field: 'email', header: 'Email Id' },
    { field: 'state.state_name', header: 'State' },
    { field: 'created', header: 'Created On', pipe: 'date:dd MMM yyyy' },
    { field: 'status', header: 'Status' },
    { field: 'action', header: 'Action', toggleable: false },
  ];

  states: any;
  selectedState: any;
  amountbalance = '2.5cr';
  selectedDate: any;
  branchData: any = [];
  pageNo: number = 0;
  rowsPerPage: number = 10;
  totalRecords: number = 10;
  displayBranch!: any;
  branchExcelData = [];
  searchText: string = "";
  onSearchTextChange: Subject<string> = new Subject<string>();
  fileUrl: string;
  fileName: string;
  branchFilters: any = { search: '' };
  selectedFile: any;
  userRole: string;
  account_id:any;

  constructor(private router: Router, private http: HttpClient, private messageService: MessageService, private exportExcelService: ExportExcelService,
    private userDashboardService: UserDashboardService, private storageService: StorageService, private branchManagementService: BranchManagementService,
    private dialogService: DialogService, private cdr: ChangeDetectorRef,
  ) {
 
    this.onSearchTextChange.pipe(debounceTime(1500)).subscribe(value => {

      this.branchFilters.search = value;
      this.getBranchDetails();
    });

    this.userRole = this.storageService.getRole()|| null;
    this.account_id = this.storageService.getAccountId()|| null;
    this.branchFilters['account_id']= this.account_id;

  }

  ngOnInit(): void {
    this.getBranchDetails()
  }

  gotoDashboard() {
    this.userRole === 'CLIENT'
      ? this.router.navigate(['doqfy/dashboard'])
      : this.router.navigate(['doqfy/admin-dashboard']);
  }

  export() {

    let data = {};
    this.exportExcelService.getbranchManagement(data).subscribe(res => {
      if (res) {
        this.exportExcelService.base64ToCSV(res['content'], "BRANCH_REPORT");
        this.messageService.add({ severity: 'success', summary: 'File downloaded successfully !', icon: 'pi-check-circle' });
      }
    });
  }




  showSuccess() {
    this.messageService.add({ severity: 'custom', summary: 'User deleted successfully!', icon: 'pi-check-circle' });
  }

  back() {
    this.userRole === 'CLIENT' ? this.router.navigate(['doqfy/dashboard']) : this.router.navigate(['doqfy/admin-dashboard']);
  }

  getBranchDetails() {
    this.branchManagementService.getBranchData(this.branchFilters).subscribe((resp: any) => {

      if (resp.status == 200) {
        if (resp.content.length != 0) {
          this.branchData = resp['content'];
          this.totalRecords = resp.pagination.total_records;
        } else {
          this.branchData = resp.content;
          this.totalRecords = 0;
        }
        this.cdr.detectChanges();
      }

    })
  }

  toggleBranchStatus(id) {
    this.branchManagementService.toggleBranchStatus(id).subscribe((res: any) => {
      this.branchData.forEach(element => {
        if (element.id === id) {
          element.is_active = !element.is_active
        }
      });
      this.cdr.detectChanges();
    })
  }
  onPageChange(event: any) {
    this.pageNo = event.first;
    this.branchFilters["page_number"] = event.page + 1
    this.branchFilters["page_size"] = event.rows;
    this.getBranchDetails();
  }

  viewBranch(branch: any): void {
    this.router.navigate(['/doqfy/management/branch-edit', branch?.id]);
  }

  onFileChange(event: any) {
    let workBook;
    let jsonData;
    const reader = new FileReader();
    const file = event.target.files[0];
    this.selectedFile = file
    reader.onload = () => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary', cellDates: true });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet);
        return initial;
      }, {});
      this.branchExcelData = jsonData.Sheet1;

      if (this.branchExcelData.length === 0) {
        this.messageService.add({ detail: 'No data found in excel. Please fill and upload again' });
        return;
      }

      const loggedInAccountId = String(this.storageService.getAccountId() ?? '').trim();
      const rowsWhere = (check: (id: string) => boolean) => this.branchExcelData
        .flatMap((row: any, i: number) => check(String(row?.account_id ?? '').trim()) ? [i + 2] : []);
      const missingRows = rowsWhere(id => !id);
      const [summary, rows]: [string, number[]] = missingRows.length
        ? ['Invalid Account ID', missingRows]
        : ['Account ID does not match logged-in account', rowsWhere(id => id !== loggedInAccountId)];

      if (rows.length) {
        this.messageService.add({ severity: 'error', summary, detail: `Row(s): ${rows.join(', ')}` });
        this.clearFile();
        return;
      }

      this.branchManagementService.createBranch(this.branchExcelData).subscribe(
        (res: any) => {
          if (res.status == 201) {
            this.dialogService.open(BulkResultComponent, {
              header: 'Bulk Upload Results',
              width: '40%',
              style: {
                'min-height': '40vh',  
                'max-height': '80vh', 
                'height': 'auto'       
              },
              data: {
                success: res.content?.success || [{ message: res.message || 'Branch created successfully' }],
                errors: res.content?.errors || [],
                entityType: 'Branch'
              }
            });
            this.getBranchDetails();
            this.clearFile()
          }
        },
      );
    };
    reader.readAsBinaryString(file);
  }
  onChangeSearchText(value) {
    this.searchText = value.toString();
    this.onSearchTextChange.next(value);
  }

  template() {
    this.fileUrl = "assets/Sample_Files_Bulk_Upload/Branch Upload.xlsx";
    this.fileName = 'bulk_branch_upload.xlsx'
    this.http.get(this.fileUrl, { responseType: 'blob' }).subscribe((response: Blob) => {
      const downloadLink = document.createElement('a');
      downloadLink.href = URL.createObjectURL(response);
      downloadLink.download = this.fileName;
      downloadLink.click();
    });
  }

  clearFile() {
    this.selectedFile = '';
    const inputElement = <HTMLInputElement>document.getElementById('upload_file');
    inputElement.value = null;
  }

  sanitizeSearchText(event: any) {
  const input = event.target as HTMLInputElement;
  // Allow only alphanumeric characters and spaces
  const sanitized = input.value.replace(/[^A-Za-z0-9 ]/g, '');
  
  if (input.value !== sanitized) {
    this.searchText = sanitized;
    input.value = sanitized;
  }
 }

}
